import { actionKeyCodes } from '../config/action-key-codes';
import throttle from '../utils/throttle';
import { slideUp, slideDown } from '../utils/animations';
import switchLinksTabIndex from '../utils/switchLinksTabIndex';

export default function cLanguageSwitcher() {
  /**
     * language switcher container
     * @type {string}
     */
  const switcherSelector = '.js-language-switcher';

  /**
     * language switcher button
     * @type {string}
     */
  const buttonSelector = '.js-lang-switcher-button';

  /**
     * language switcher current item
     * @type {string}
     */
  const currentLanguageLabelSelector = '.js-lang-switcher-current-label';

  /**
     * language switcher list
     * @type {string}
     */
  const languagesListSelector = '.js-lang-switcher-languages-list';

  /**
     * language switcher last item link
     * @type {string}
     */
  const languagesListLastItemSelector = '.js-lang-switcher-language-item:last-child a';

  /**
     * class open
     * @type {string}
     */
  const currentLanguageLabelOpenClass = 'c-language-switcher__current--open';

  /**
   * Language switcher open
   * @param {Element} switcher
   */
  function languageSwitcherOpen(switcher) {
    const currentLanguageLabel = switcher.querySelector(currentLanguageLabelSelector);
    const button = switcher.querySelector(buttonSelector);
    const languagesList = switcher.querySelector(languagesListSelector);

    switcher.setAttribute('data-expanded', 'true');
    button.setAttribute('aria-expanded', 'true');
    currentLanguageLabel.classList.add(currentLanguageLabelOpenClass);
    switchLinksTabIndex(languagesList, '0', 200);
    slideDown(languagesList);
  }

  /**
   * Language switcher close
   * @param {Element} switcher
   */
  function languageSwitcherClose(switcher) {
    const currentLanguageLabel = switcher.querySelector(currentLanguageLabelSelector);
    const button = switcher.querySelector(buttonSelector);
    const languagesList = switcher.querySelector(languagesListSelector);

    switcher.setAttribute('data-expanded', 'false');
    button.setAttribute('aria-expanded', 'false');
    currentLanguageLabel.classList.remove(currentLanguageLabelOpenClass);
    switchLinksTabIndex(languagesList, '-1', 200);
    slideUp(languagesList);
  }

  /**
   * Search for active switchers
   * @return {NodeListOf<Element>}
   */
  function getActiveSwitchers() {
    return document.querySelectorAll(`${switcherSelector}[data-expanded="true"]`);
  }

  /**
   * Language switcher toggle
   * @returns {boolean}
   */
  function languageSwitcherToggle(switcher) {
    if (switcher.getAttribute('data-expanded') === 'true') {
      languageSwitcherClose(switcher);
    } else {
      languageSwitcherOpen(switcher);
    }

    return false;
  }

  /**
   * Close active language switchers if any exist
   */
  function closeActiveLanguageSwitchers() {
    getActiveSwitchers().forEach((switcher) => {
      languageSwitcherClose(switcher);
    });
  }

  // open/close logic
  document.querySelectorAll(buttonSelector).forEach((button) => {
    button.addEventListener('click', (event) => {
      if (!actionKeyCodes.includes(event.keyCode)) {
        return false;
      }

      return languageSwitcherToggle(event.target.closest(switcherSelector));
    });
  });

  // focus handler
  document.querySelectorAll(languagesListLastItemSelector).forEach((lastItem) => {
    lastItem.addEventListener('keydown', (event) => {
      if (event.keyCode !== 9) {
        return false;
      }

      const button = lastItem.closest(switcherSelector).querySelector(buttonSelector);

      return setTimeout(() => {
        button.focus();
      }, 0);
    });
  });

  // click outside handler
  document.addEventListener('click', (event) => {
    getActiveSwitchers().forEach((switcher) => {
      if (!switcher.contains(event.target)) {
        languageSwitcherClose(switcher);
      }
    });
  });

  window.addEventListener('scroll', throttle(closeActiveLanguageSwitchers, 100));
}
